import React, { useState } from 'react'

// BL
import { FinancialAccountReconciliationWithTransactions } from '@/reducers/admin/allFinancialAccountReconciliationsReducer'
import { ReactClickSignature } from '../shared'

// UI
import { Menu, Button, Label } from 'semantic-ui-react'
import { FinancialAccountSumResponse } from '@/actions/admin/adminFinancialAccountActions'
import { DATE_FORMATS_LUXON, toUTCDateString } from '@/utils/dateHelpers'
import ReopenReconciliationModal from './ReopenReconciliationModal'

interface Props {
  account: FinancialAccountSumResponse | null
  onBackClicked: ReactClickSignature
  reconciliation: FinancialAccountReconciliationWithTransactions
  onReopened?: () => void
}

const ReconciliationToolbar: React.FC<Props> = ({
  account,
  reconciliation,
  onBackClicked,
  onReopened,
}) => {
  const [reopenOpen, setReopenOpen] = useState(false)
  const startDateFormatted = toUTCDateString({
    value: reconciliation.startingBalanceDate,
    format: DATE_FORMATS_LUXON.DISPLAY_LONG,
  })
  const endDateFormatted = toUTCDateString({
    value: reconciliation.endingBalanceDate,
    format: DATE_FORMATS_LUXON.DISPLAY_LONG,
  })
  const labelColor = ['incomplete', 'blocked'].includes(reconciliation.status)
    ? 'red'
    : 'green'
  return (
    <Menu borderless className="mute reconciliation-toolbar">
      <Menu.Item>
        <Button className="mute" onClick={onBackClicked} icon="arrow left" />
        <h4>
          {account?.plaidInstitutionName} {account?.name}: {account?.mask}
        </h4>
      </Menu.Item>
      <Menu.Item position="right">
        Period of <strong>{startDateFormatted}</strong> to{' '}
        <strong>{endDateFormatted}</strong>
        <Label color={labelColor}>{reconciliation.status}</Label>
        {reconciliation.status === 'complete' && (
          <>
            <Button className="mute" onClick={() => setReopenOpen(true)}>
              Reopen
            </Button>
            <ReopenReconciliationModal
              reconciliationId={reconciliation.id}
              open={reopenOpen}
              close={() => setReopenOpen(false)}
              onReopened={onReopened}
            />
          </>
        )}
      </Menu.Item>
    </Menu>
  )
}

export default ReconciliationToolbar
